import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import BasicInput from "../custom/BasicInput";
import { CustomFieldType } from "../../constants/CoreConstants";
import BasicFormControlWithLabelV2 from "../custom/BasicFormControlWithLabelV2";

export const renderEachCustomField = (data, index, onChange, previousData) => {
  const placeholderColor = "#929da9";
  const activeColor = "#36454F";
  let type_id = data.type_id;
  let _values =
    typeof previousData[index] !== "undefined" && previousData[index] != null
      ? typeof previousData[index].value !== "undefined"
        ? type_id === CustomFieldType.CHECKBOX
          ? previousData[index].value.split(",")
          : previousData[index].value
        : ""
      : "";

  // Date normalization from DynamicInputField
  const normalizeDate = (dateStr) => {
    if (!dateStr || typeof dateStr !== "string") return "";
    dateStr = dateStr.trim();

    // Format: YYYY-MM-DD
    if (dateStr.includes("-")) {
      let [year, month, day] = dateStr.split("-");

      year = year.slice(-4); // ✅ last 4 digits
      month = month.padStart(2, "0");
      day = day.padStart(2, "0");

      return `${month}/${day}/${year}`;
    }

    // Format: MM/DD/YYYY (or longer year)
    if (dateStr.includes("/")) {
      let [month, day, year] = dateStr.split("/");

      if (!year || !month || !day) return "";

      year = year.slice(-4); // ✅ last 4 digits
      month = month.padStart(2, "0");
      day = day.padStart(2, "0");

      return `${month}/${day}/${year}`;
    }
    return "";
  };

  // Datetime normalization from DynamicInputField
  const normalizeDateTime = (dateTimeStr) => {
    if (!dateTimeStr || typeof dateTimeStr !== "string") return "";
    dateTimeStr = dateTimeStr.trim();

    const [datePart, timePartRaw] = dateTimeStr.split("T");
    if (!datePart || !timePartRaw) return "";

    const formattedDate = normalizeDate(datePart);
    if (!formattedDate) return "";

    const timePart = timePartRaw.split(".")[0]; // Remove milliseconds if present
    return `${formattedDate} ${timePart}`;
  };

  // Convert to ISO date for display (YYYY-MM-DD)
  function convertToISODate(input) {
    if (!input || typeof input !== "string") {
      // console.warn("Invalid input: Not a string or is empty.");
      return "";
    }

    // Check if already in ISO format
    const isoRegex = /^\d{4}-\d{2}-\d{2}$/;
    if (isoRegex.test(input)) {
      // console.log("Input is already in ISO format.");
      return input;
    }

    // Match MM/DD/YYYY or M/D/YYYY
    const regex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const match = input.match(regex);

    if (!match) {
      // console.warn("Input does not match MM/DD/YYYY format.");
      return "";
    }

    let [_, mm, dd, yyyy] = match;

    // Pad month and day with leading zeros
    const paddedMM = mm.padStart(2, "0");
    const paddedDD = dd.padStart(2, "0");

    const isoFormatted = `${yyyy}-${paddedMM}-${paddedDD}`;
    console.log("Converted to ISO format:", isoFormatted);
    return isoFormatted;
  }

  // Convert to ISO datetime for display (YYYY-MM-DDTHH:mm)
  function convertToISODatetime(input) {
    if (!input || typeof input !== "string") return "";

    input = input.trim();
    console.log("Converted to ISO format:", input);

    // Case 1: Already ISO-like with time (YYYY-MM-DDTHH:mm or YYYY-MM-DD HH:mm)
    const isoRegex = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}(:\d{2})?$/;
    if (isoRegex.test(input)) {
      const [datePart, timePart] = input.split(/[ T]/);
      const [year, month, day] = datePart.split("-");
      const [hh, min] = timePart.split(":");
      return `${year}-${month}-${day}T${hh.padStart(2, "0")}:${min.padStart(
        2,
        "0"
      )}`;
    }

    // Case 2: MM/DD/YYYY HH:mm (or with seconds)
    const fullDateTimeRegex =
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/;
    const fullMatch = input.match(fullDateTimeRegex);
    if (fullMatch) {
      const [_, mm, dd, yyyy, hh, min] = fullMatch;
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(
        2,
        "0"
      )}T${hh.padStart(2, "0")}:${min.padStart(2, "0")}`;
    }

    // Case 3: MM/DD/YYYY → default time to 00:00
    const usDateOnlyRegex = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/;
    const usDateMatch = input.match(usDateOnlyRegex);
    if (usDateMatch) {
      const [_, mm, dd, yyyy] = usDateMatch;
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}T00:00`;
    }

    // ✅ Case 4: YYYY-MM-DD (ISO date only) → default time to 00:00
    const isoDateOnlyRegex = /^(\d{4})-(\d{1,2})-(\d{1,2})$/;
    const isoDateMatch = input.match(isoDateOnlyRegex);
    if (isoDateMatch) {
      const [_, yyyy, mm, dd] = isoDateMatch;
      return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}T00:00`;
    }

    return ""; // Fallback if nothing matches
  }

  const handleOnChange = (e, self) => {
    let value = e.target.value;

    if (
      type_id === CustomFieldType.NUMERIC ||
      type_id === CustomFieldType.ZIP_CODE
    ) {
      onChange(value, index, data.id, data?.max_length);
    } else if (type_id === CustomFieldType.CHECKBOX) {
      let previous_value =
          typeof previousData[index] !== "undefined" &&
          previousData[index] != null
            ? typeof previousData[index].value !== "undefined"
              ? previousData[index].value
              : ""
            : "",
        new_value = "";
      if (e.target.checked) {
        if (previous_value.trim() === "") {
          new_value = e.target.value;
        } else {
          new_value = previous_value + "," + e.target.value;
        }
      } else {
        if (previous_value.indexOf(e.target.value) !== -1) {
          let value_array = previous_value.split(",");
          value_array.forEach((each_data, each_index) => {
            if (each_data !== e.target.value) {
              if (new_value === "") {
                new_value += each_data;
              } else {
                new_value = new_value + "," + each_data;
              }
            }
          });
        }
      }
      onChange(new_value, index, data.id);
    } else if (type_id === CustomFieldType.DATE) {
      value = normalizeDate(value); // Store as MM/DD/YYYY
      onChange(value, index, data.id);
    } else if (type_id === CustomFieldType.DATETIME) {
      value = normalizeDateTime(value); // Store as MM/DD/YYYY HH:mm:ss
      onChange(value, index, data.id);
    } else if (type_id === CustomFieldType.RADIO) {
      onChange(value, index, data.id);
    } else {
      onChange(value, index, data.id);
    }
  };

  if (
    type_id === CustomFieldType.TEXT ||
    type_id === CustomFieldType.MULTILINE_TEXT ||
    type_id === CustomFieldType.NUMERIC ||
    type_id === CustomFieldType.DATE ||
    type_id === CustomFieldType.DATETIME ||
    type_id === CustomFieldType.PHONE ||
    type_id === CustomFieldType.ZIP_CODE ||
    type_id === CustomFieldType.WEBSITE ||
    type_id === CustomFieldType.CHECKBOX ||
    type_id === CustomFieldType.RADIO ||
    type_id === CustomFieldType.SELECT
  ) {
    return (
      <div
        className="col s12 m12"
        key={`${type_id} ${index}`}
        style={{ marginBottom: 0, marginTop: "16px" }}
      >
          {(type_id === CustomFieldType.TEXT ||
              type_id === CustomFieldType.PHONE) && (
              <BasicFormControlWithLabelV2
                  label={data?.title}
                  fullWidth
                  type="text"
                  id={`custom-field-${index}`}
                  value={previousData[index]?.value || ""}
                  maxLength={data?.max_length}
                  onChange={(e) => handleOnChange(e)}
                  component={BasicInput}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& input': {
                          border: 'none !important'
                      }
                  }}
              />
          )}

        {type_id === CustomFieldType.MULTILINE_TEXT && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                rows="5"
                id={`custom-field-${index}`}
                onChange={(e) => handleOnChange(e)}
                value={previousData?.[index]?.value}
                multiline
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& textarea': {
                        border: 'none !important'
                    }
                }}
            />
        )}

          {(type_id === CustomFieldType.NUMERIC ||
          type_id === CustomFieldType.ZIP_CODE) && (
              <BasicFormControlWithLabelV2
                  label={data?.title}
                  fullWidth
                  type="number"
                  id={`custom-field-${index}`}
                  value={previousData?.[index]?.value}
                  maxLength={data?.max_length}
                  pattern="[0-9]{11}"
                  onChange={(e) => handleOnChange(e)}
                  component={BasicInput}
                  sx={{
                      '& .MuiInputBase-root': {
                          marginTop: 0,
                      },
                      '& input': {
                          border: 'none !important'
                      }
                  }}
              />
        )}

        {type_id === CustomFieldType.DATE && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                className={`custom-date-input`}
                type="date"
                id={`custom-field-${index}`}
                value={convertToISODate(_values)} // Display as YYYY-MM-DD
                onChange={(e) => handleOnChange(e)}
                style={{color: convertToISODate(_values) ? activeColor : placeholderColor}}
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.DATETIME && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                className={`custom-date-input`}
                type="datetime-local"
                id={`custom-field-${index}`}
                value={convertToISODatetime(_values)} // Display as YYYY-MM-DDTHH:mm
                onChange={(e) => handleOnChange(e)}
                style={{color: convertToISODatetime(_values) ? activeColor : placeholderColor}}
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.WEBSITE && (
            <BasicFormControlWithLabelV2
                label={data?.title}
                fullWidth
                type="url"
                id={`custom-field-${index}`}
                value={previousData?.[index]?.value}
                maxLength={data?.max_length}
                pattern="[0-9]{11}"
                onChange={(e) => handleOnChange(e)}
                component={BasicInput}
                sx={{
                    '& .MuiInputBase-root': {
                        marginTop: 0,
                    },
                    '& input': {
                        border: 'none !important'
                    }
                }}
            />
        )}

        {type_id === CustomFieldType.CHECKBOX && (
          <div className="check-box-input-groups">
            <FormGroup row className="custom_check_box_container">
              {data.default_values &&
                Array.isArray(data.default_values) &&
                data.default_values.map((each, each_index) => {
                  let isChecked = _values.indexOf(each) !== -1 ? true : false;
                  return (
                    <FormControlLabel
                      className="custom_check_box"
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={handleOnChange}
                          name={`${index}-${data.personalize_tag}[]`}
                          value={each}
                          // style={{ padding: "12px" }}
                        />
                      }
                      label={each}
                    />
                  );
                })}
            </FormGroup>
          </div>
        )}

        {type_id === CustomFieldType.RADIO && (
          <div className="radio-button-input-groups">
            <RadioGroup
              row
              aria-label={index + "-" + data.personalize_tag}
              name={index + "-" + data.personalize_tag}
              value={_values}
              onChange={handleOnChange}
            >
              {data.default_values &&
                Array.isArray(data.default_values) &&
                data.default_values.map((each, each_index) => {
                  return (
                    <FormControlLabel
                      value={each}
                      control={<Radio style={{ padding: "12px" }} />}
                      label={each}
                    />
                  );
                })}
            </RadioGroup>
          </div>
        )}

        {type_id === CustomFieldType.SELECT && (
          <select
            className="form-control h-100 d-block"
            placeholder={"Please Select"}
            name={`add_contact_custom_field${data.personalize_tag}`}
            onChange={(e) => handleOnChange(e)}
            style={{
              marginTop: 10,
              height: "2.5rem",
              fontSize: "15px",
              color: `${data.default_values ? placeholderColor : activeColor}`,
            }}
          >
            <option value="" key={-1}>
              {data.title}
            </option>
            {data.default_values &&
              Array.isArray(data.default_values) &&
              data.default_values.map((each, each_index) => {
                if (
                  previousData[index] !== undefined &&
                  previousData[index] != null &&
                  previousData[index].value === each
                ) {
                  return (
                    <option
                      value={each}
                      key={`custom-select-${each_index}`}
                      selected
                    >
                      {each}
                    </option>
                  );
                } else
                  return (
                    <option value={each} key={`custom-select-${each_index}`}>
                      {each}
                    </option>
                  );
              })}
          </select>
        )}
      </div>
    );
  }

  return null;
};
